import { format } from "date-fns";
import { getCurrentLocalDateTime } from "../../../utils/getLocalDateTime";
import _ from "lodash";
import { Storage } from "aws-amplify";

const getDifferenceInDays = (date1, date2) => {
  date1 = getCurrentLocalDateTime(date1).fullDate;
  date2 = getCurrentLocalDateTime(date2).fullDate;

  const diffInMs = new Date(date2) - new Date(date1);
  return Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
};

const getLastItem = (lastItem) => {
  let lastItemStr = "";
  if (lastItem) {
    const lastItemKeys = Object.keys(lastItem);
    lastItemKeys.forEach((key) => {
      lastItemStr += `${key}=${lastItem[key]}&`;
    });
  }
  return lastItemStr;
};

//interest = 21
//capital = 30,000
//numberOfInstallment = 24
//สูตรคำนวณต่องวด
const calculatePayPerMonth = (capital, interest, numberOfInstallment) => {
  let interestPerInstallment = interest / (100 * 12); //ดอกเบี้ยต่องวดประจำปี 0.0175
  let power = 1 - 1 / Math.pow(1 + interestPerInstallment, numberOfInstallment); //0.34
  let finalDividend = power / interestPerInstallment; //19.46
  let result = capital / finalDividend; //1541.56
  // return Number(Number(result).toFixed(2));
  return roundUp(result, 0);
  // return roundUp(result, 0);
};

const getFormatDate = (date, formatDate = "dd-MM-yyyy") => {
  let dumpDate = new Date(date);
  if (date === "-") {
    return "";
  } else if (dumpDate instanceof Date && !isNaN(dumpDate)) {
    return format(dumpDate, formatDate);
  } else {
    return "Invalid Date";
  }
};

const calculatePayPerMonthReduction = (
  capital,
  interest,
  numberOfInstallment
) => {
  const R3 = Number(capital);
  const R5 = Number(interest) / 100;
  const R4 = Number(numberOfInstallment);
  const result = round(R3 / ((1 - 1 / (1 + R5) ** R4) / R5), 0);
  return result;
};

const calInterestReduction = (capital, interest, numberOfInstallment) => {
  const amount = Number(
    calculatePayPerMonthPerYear(capital, interest, numberOfInstallment)
  );
  // =RATE(L4,M6,-M3,0,0)
  const L4 = Number(numberOfInstallment);
  const M6 = Number(amount);
  const M3 = -Number(capital);
  const rate = RATE(L4, M6, M3, 0, 0) * 100;
  return roundUp(rate, 4);
};

const calculatePayPerMonthPerYear = (
  capital,
  interest,
  numberOfInstallment
) => {
  const M3 = Number(capital); // 190300;
  const M5 = Number(interest) / 100; // 5.4 / 100;
  const M4 = Number(numberOfInstallment) / 12; // 6;
  const L4 = Number(numberOfInstallment); // 72
  return roundUp((M3 * M5 * M4 + M3) / L4, 0);
};

const getFilterInstallments = (installments = []) => {
  return installments
    .map((installment) => {
      if (installment.pre_installments.length > 0) {
        return {
          _id: installment.id,
          isPlus: true,
          ...installment,
        };
      }
      return null;
    })
    .filter((installment) => installment);
};

const getCapital = (form) => {
  if (form.type === "CAR") {
    return form.capital;
  }
  return getCapitalRemainMotobike(form.capital, form.loanFee);
};

const getCapitalRemainMotobike = (capital, loanFee) => {
  return Number(Number(capital) + getFee(capital, loanFee));
};

const getDiffRemain = (value, paidValue) => {
  return getNumberTwoDecimal(value - paidValue);
};

const round = (number, digits) => {
  var factor = Math.pow(10, digits);
  return Math.round(number * factor) / factor;
};

const roundUp = (number, digits) => {
  var factor = Math.pow(10, digits);
  return Math.ceil(number * factor) / factor;
};

const getAmount = (form) => {
  const { type, capital, loanFee } = form;
  if (type === "CAR") {
    return Number(capital);
  }
  return Number(capital) + capital * (loanFee / 100);
};

const getPercent = (value) => {
  return Number(value) / 100;
};

const getFee = (capital, feeValue) => {
  return Number(capital) * getPercent(feeValue);
};

const getFeeMotobike = (capital, loanFee, stamp) => {
  return (
    (Number(capital) + getFee(capital, loanFee)) *
    Number(stamp * (capital / 100))
  );
};

const getReceiveAmountMotobike = (form) => {
  const { capital, loanFee, stamp } = form;
  return getNumberTwoDecimal(
    Number(capital) - getFeeMotobike(capital, loanFee, stamp)
  );
};

const getReceiveAmountCar = (form) => {
  const { capital, loanFee, stamp } = form;
  return getNumberTwoDecimal(
    Number(capital) -
      (Number(loanFee * (capital / 100)) + Number(stamp * (capital / 100)))
  );
};

const getSysUpdateBy = (pre_installment) => {
  if (pre_installment.pre_status === "DUEDATE") {
    return `D`;
  } else if (pre_installment.pre_status === "PAID") {
    return "P";
  }
  return "";
};

const getNumberTwoDecimal = (number) => {
  // return Number(Number(number).toFixed(2));
  return round(number, 2);
};

const getTotalNTF = (pre_installment) => {
  return (
    pre_installment.principle +
    pre_installment.principle_vat +
    pre_installment.interest +
    pre_installment.interest_vat +
    pre_installment.penalty +
    pre_installment.demand_fee +
    pre_installment.visit_fee
  );
};

const getPaidTotalNTF = (pre_installment) => {
  return (
    pre_installment.paidPrinciple +
    pre_installment.paidPrincipleVat +
    pre_installment.paidInterest +
    pre_installment.paidInterestVat +
    pre_installment.paidDemandFee +
    pre_installment.paidPenalty +
    pre_installment.paidOverflow +
    pre_installment.paidVisitFee
  );
};

const calPaidRemain = (paid = 0, original = 0) => {
  return Number(Number(Number(original) - Number(paid)).toFixed(2));
};

const calTotalLeasing = (installment, leasing) => {
  return getNumberTwoDecimal(
    `${
      calPaidRemain(installment.paidPrinciple, installment.principle) +
      calPaidRemain(installment.paidPrincipleVat, installment.principle_vat) +
      calPaidRemain(installment.paidInterest, installment.interest) +
      calPaidRemain(installment.paidInterestVat, installment.interest_vat) +
      calPaidRemain(installment.paidPenalty, installment.penalty) +
      calPaidRemain(installment.paidDemandFee, installment.demand_fee) +
      calPaidRemain(installment.paidVisitFee, installment.visit_fee)
    }`
  );
};

const RATE = (periods, payment, present, future, type, guess) => {
  guess = guess === undefined ? 0.01 : guess;
  future = future === undefined ? 0 : future;
  type = type === undefined ? 0 : type;

  // Set maximum epsilon for end of iteration
  var epsMax = 1e-10;

  // Set maximum number of iterations
  var iterMax = 10;

  // Implement Newton's method
  var y,
    y0,
    y1,
    x0,
    x1 = 0,
    f = 0,
    i = 0;
  var rate = guess;
  if (Math.abs(rate) < epsMax) {
    y =
      present * (1 + periods * rate) +
      payment * (1 + rate * type) * periods +
      future;
  } else {
    f = Math.exp(periods * Math.log(1 + rate));
    y = present * f + payment * (1 / rate + type) * (f - 1) + future;
  }
  y0 = present + payment * periods + future;
  y1 = present * f + payment * (1 / rate + type) * (f - 1) + future;
  i = x0 = 0;
  x1 = rate;
  while (Math.abs(y0 - y1) > epsMax && i < iterMax) {
    rate = (y1 * x0 - y0 * x1) / (y1 - y0);
    x0 = x1;
    x1 = rate;
    if (Math.abs(rate) < epsMax) {
      y =
        present * (1 + periods * rate) +
        payment * (1 + rate * type) * periods +
        future;
    } else {
      f = Math.exp(periods * Math.log(1 + rate));
      y = present * f + payment * (1 / rate + type) * (f - 1) + future;
    }
    y0 = y1;
    y1 = y;
    ++i;
  }
  return rate;
};

const getStyleStatus = (status) => {
  switch (status) {
    case "ยกเลิกนัดหมาย":
      return "text-red-500";
    case "ยกเลิก":
      return "text-orange-600";
    case "งานสำเร็จแล้ว":
      return "text-mhs-buttonblue-100";
    case "รอนัดหมาย":
      return "text-mhs-orange";
    case "รอตรวจ":
      return "text-emerald-500";
    case "นัดหมายแล้ว":
      return "text-mhs-yellow";
    case "ยังไม่ได้นัดหมาย":
      return "text-mhs-orange";
    case "ไม่สมบูรณ์":
      return "text-mhs-red";
    case "รออนุมัติ":
      return "text-yellow-500";
    case "ไม่ผ่าน":
      return "text-red-500";
    case "รอผู้ยื่นคำร้องแก้ไข":
      return "text-pink-500";
    case "รับคำร้อง":
      return "text-gray-500";
    case "รอติดต่อบุคคลอ้างอิง":
      return "text-orange-500";
    case "ยืนยัน":
      return "text-purple-500";
    case "อนุมัติ":
      return "text-green-500";
    case "สมบูรณ์":
      return "text-green-500";
    default:
      console.log("UNKNOWN STATUS", status);
      break;
  }
};

const getFeeTypeText = (feeType) => {
  switch (feeType) {
    case "visit_fee":
      return "ค่าลงพื้นที่";
    case "break_fee":
      return "ค่ายกเลิกสัญญา";
    case "demand_fee":
      return "ค่าท่วงถาม";
    case "service_fee":
      return "ค่าบริการ";
    case "return_car_fee":
      return "ค่าคืนยานพาหนะ";
    default:
      console.log("UNKNOWN STATUS", feeType);
      break;
  }
};

const calTotalLeasingWithOutPrinciple = (leasing, installment) => {
  return getNumberTwoDecimal(
    `${
      calPaidRemain(installment.paidInterest, installment.interest) +
      calPaidRemain(installment.paidPenalty, installment.penalty) +
      calPaidRemain(installment.paidDemandFee, installment.demand_fee) +
      calPaidRemain(installment.paidVisitFee, installment.visit_fee)
    }`
  );
};

const getTotalOfPreInstallmentsWithOutPrinciple = (
  leasing,
  installments = []
) => {
  let total = 0;
  for (const installment of installments) {
    if (installment.disabledPeriod) {
      continue;
    }
    if (installment.pre_installments.length > 0) {
      const last_pre_installment =
        installment.pre_installments[installment.pre_installments.length - 1];
      total += calTotalLeasingWithOutPrinciple(leasing, last_pre_installment);
    }
  }
  return getNumberTwoDecimal(total);
};

// MARK ไม่ได้ใช้
const getAmountReturnCarFee = (leasing, RETURN_CAR, formatPaidDate) => {
  const totalLeasing = getTotalOfPreInstallmentsWithOutPrinciple(
    leasing,
    leasing.installments
  );
  const diffDate = getDifferenceInDays(
    new Date(leasing.breakFeeDate),
    new Date(formatPaidDate)
  );
  const totalReturnCarFee = getNumberTwoDecimal(
    totalLeasing + Number(leasing.break_fee) + leasing.capitalRemain
  );
  const totalFinal =
    totalReturnCarFee +
    (totalReturnCarFee * getPercent(RETURN_CAR) * diffDate) / 365;

  return getNumberTwoDecimal(totalFinal);
};

const daysInYear = (year = new Date().getFullYear()) => {
  return (year % 4 === 0 && year % 100 > 0) || year % 400 === 0 ? 366 : 365;
};

const convertTimeSeven = (isoDateTime) => {
  const splitDate = String(isoDateTime).split("+");
  if (splitDate.length > 0) {
    return splitDate[0];
  }
  return isoDateTime;
};

const getAmountPlusReturnCarFee = (
  loan,
  date = new Date(),
  RETURN_CAR,
  RETURN_CAR_DATE
) => {
  if (["DONE"].includes(loan?.loan_status) || loan?.paid_cancel_total_daily > 0)
    return 0;
  let formatPaidDate = getCurrentLocalDateTime(date).fullDate;
  if (loan?.seize_date !== "-") {
    if (loan?.seize_date >= loan?.breakFeeDate) {
      const diffLatestPaidDate = getDifferenceInDays(
        new Date(loan?.breakFeeDate),
        new Date(convertTimeSeven(loan?.seize_date))
      );
      const amount = getNumberTwoDecimal(
        (diffLatestPaidDate - RETURN_CAR_DATE) * RETURN_CAR
      );
      return amount > 0 ? amount : 0;
    }
    return 0;
  } else if (loan?.paidDateLatest !== "-") {
    if (loan?.paidDateLatest >= loan?.breakFeeDate) {
      const diffLatestPaidDate = getDifferenceInDays(
        new Date(convertTimeSeven(loan?.paidDateLatest)),
        new Date(formatPaidDate)
      );
      const amount = getNumberTwoDecimal(diffLatestPaidDate * RETURN_CAR);
      return amount > 0 ? amount : 0;
    } else {
      const diffDate = getDifferenceInDays(
        new Date(loan?.breakFeeDate),
        new Date(formatPaidDate)
      );
      if (diffDate > RETURN_CAR_DATE) {
        const amount = getNumberTwoDecimal(
          (diffDate - RETURN_CAR_DATE) * RETURN_CAR
        );
        return amount > 0 ? amount : 0;
      }
    }
    return 0;
  } else {
    const diffDate = getDifferenceInDays(
      new Date(loan?.breakFeeDate),
      new Date(formatPaidDate)
    );
    if (diffDate > RETURN_CAR_DATE) {
      const amount = getNumberTwoDecimal(
        (diffDate - RETURN_CAR_DATE) * RETURN_CAR
      );
      return amount > 0 ? amount : 0;
    }
    return 0;
  }
};

const prePareQueryRequest = (form, searchBy, searchBar, isTransfer = false) => {
  if (form.status) {
    form.status = form.status.value;
  }
  if (form.category) {
    form.category = form.category.value;
  }
  if (form.reserveBy) {
    form.reserveBy = form.reserveBy.value;
  }

  if (form.min) {
    form.min = getCurrentLocalDateTime(form.min).fullDate;
  }

  if (form.max) {
    form.max = getCurrentLocalDateTime(form.max).fullDate;
  }

  if (form.Limit) {
    if (form?.Limit?.value) {
      form.Limit = Number(form?.Limit?.value);
    } else {
      form.Limit = Number(form?.Limit);
    }
  }

  if (isTransfer) {
    delete form?.reserveBy;
  }

  return { ...form, [searchBy]: searchBar?.value || "" };
};

const getLastDemandFee = (installments = []) => {
  let demand_fee = 0;
  for (const installment of installments) {
    if (
      !installment.disabledPeriod &&
      installment.pre_installments.length > 0
    ) {
      const last_pre_installment =
        installment.pre_installments[installment.pre_installments.length - 1];
      if (last_pre_installment.pre_type === "LATE") {
        demand_fee = last_pre_installment.temp_demand_fee;
      }
    }
  }
  return demand_fee;
};

const getDifferenceInDaysPlusOne = (date1, date2) => {
  date1 = getCurrentLocalDateTime(date1).fullDate;
  date2 = getCurrentLocalDateTime(date2).fullDate;

  const diffInMs = new Date(date2) - new Date(date1);
  return Math.ceil(diffInMs / (1000 * 60 * 60 * 24)) + 1;
};

const convertTimeToDate = (isoDateTime) => {
  const splitDate = String(isoDateTime).split("T");
  if (splitDate.length > 0) {
    return splitDate[0];
  }
  return isoDateTime;
};

const getTotalOfPreInstallmentsHalf = (
  installments = [],
  paidDate,
  INTEREST_PENALTY_DATE
) => {
  let clone_installments = _.cloneDeep(installments);
  let index = 0;
  let count = 0;
  let countDisabled = 0;
  let countEnabled = 0;
  let countList = [];
  let discountInterest = 0;
  let total_obj = {
    close_total_principle: 0,
    close_total_principle_vat: 0,
    close_total_interest: 0,
    close_total_interest_vat: 0,
    close_total_interest_all: 0,
    close_total_penalty: 0,
    close_total_demand_fee: 0,
    close_total_visit_fee: 0,
  };

  for (const installment of clone_installments) {
    if (installment?.disabledPeriod) {
      countDisabled++;
    } else {
      countEnabled++;
    }
  }

  // if (countDisabled >= 16) {
  //   discountInterest = 0;
  // } else if (countDisabled >= 8) {
  //   discountInterest = 0.7;
  // } else {
  //   discountInterest = 0.6;
  // }

  const cal_count_disabled = Math.ceil(
    clone_installments.length / countDisabled
  );

  if (cal_count_disabled <= 2) {
    discountInterest = 0;
  } else if (cal_count_disabled === 3) {
    discountInterest = 0.7;
  } else {
    discountInterest = 0.6;
  }

  for (const clone_installment of clone_installments) {
    if (!clone_installment.disabledPeriod) {
      if (clone_installment.pre_installments.length > 0) {
        let last_pre_installment =
          clone_installment.pre_installments[
            clone_installment.pre_installments.length - 1
          ];
        if (last_pre_installment) {
          let diffLateDuration = getDifferenceInDaysPlusOne(
            clone_installment.dueDate,
            paidDate
          );

          if (
            !last_pre_installment.disabledPeriod &&
            diffLateDuration <= 0
            // &&
            // diffLateDuration + INTEREST_PENALTY_DATE < 0
          ) {
            count++;
            let before_interest = last_pre_installment.interest;
            last_pre_installment.before_interest = before_interest;
            if (discountInterest === 0) {
              last_pre_installment.interest = 0;
            } else {
              total_obj.close_total_interest_all +=
                last_pre_installment.interest;
              last_pre_installment.interest -= getNumberTwoDecimal(
                last_pre_installment.interest * discountInterest
              );
            }
            countList.push({
              before_interest,
              after_interest: last_pre_installment.interest,
              period: last_pre_installment.period,
            });
          }
        }

        total_obj.close_total_interest_all = getNumberTwoDecimal(
          total_obj?.close_total_interest_all
        );
        total_obj.close_total_principle = getNumberTwoDecimal(
          total_obj.close_total_principle + last_pre_installment.principle
        );
        total_obj.close_total_principle_vat = getNumberTwoDecimal(
          total_obj.close_total_principle_vat +
            last_pre_installment.principle_vat
        );
        total_obj.close_total_interest = getNumberTwoDecimal(
          total_obj.close_total_interest + last_pre_installment.interest
        );
        total_obj.close_total_interest_vat = getNumberTwoDecimal(
          total_obj.close_total_interest_vat + last_pre_installment.interest_vat
        );
        total_obj.close_total_penalty = getNumberTwoDecimal(
          total_obj.close_total_penalty + last_pre_installment.penalty
        );
        total_obj.close_total_demand_fee = getNumberTwoDecimal(
          total_obj.close_total_demand_fee + last_pre_installment.demand_fee
        );
        total_obj.close_total_visit_fee = getNumberTwoDecimal(
          total_obj.close_total_visit_fee + last_pre_installment.visit_fee
        );
      }
    }
    index++;
  }

  const total = Object.keys(total_obj).reduce((prev, key) => {
    if (key === "close_total_interest_all") return prev;
    return prev + total_obj[key];
  }, 0);

  const mergeTotalObj = {
    close_total: getNumberTwoDecimal(total),
    discountInterest,
    ...total_obj,
  };

  // console.log("count", count);
  // console.log("countList", countList);
  return { ...mergeTotalObj, clone_installments };
};

const getAmountOwedDueNTF = (leasing, installments = []) => {
  const today = getCurrentLocalDateTime().fullDate;
  let total = 0;
  for (const installment of installments) {
    if (installment.dueDate <= today) {
      if (installment.pre_installments.length > 0) {
        const last_pre_installment =
          installment.pre_installments[installment.pre_installments.length - 1];
        total += getNumberTwoDecimal(
          last_pre_installment.principle - last_pre_installment.paidPrinciple
        );
      }
    }
  }
  return total;
};

const getAmountOwedDueTF = (leasing, installments = []) => {
  const today = getCurrentLocalDateTime().fullDate;
  let total = 0;
  for (const installment of installments) {
    if (installment.dueDate <= today) {
      if (installment.pre_installments.length > 0) {
        const last_pre_installment =
          installment.pre_installments[installment.pre_installments.length - 1];
        total += getNumberTwoDecimal(
          last_pre_installment.principle - last_pre_installment.paidPrinciple
        );
      }
    }
  }
  return total;
};

const getBeforeVat = (paidAmount = 0) => {
  return getNumberTwoDecimal((paidAmount * 100) / 107);
};

const getAfterVat = (paidAmount) => {
  return getNumberTwoDecimal(paidAmount - getBeforeVat(paidAmount));
};

function tryParseJSON(jsonString) {
  try {
    var o = JSON.parse(jsonString);
    if (o && typeof o === "object") {
      return o;
    }
  } catch (e) {}

  return false;
}
const getStatments = async (statement) => {
  var arr = [];
  for (let i = 0; i < statement.length; i++) {
    let value = await Storage.get(statement[i]);
    arr.push({ value, display: false, file: "" });
  }
  return arr;
};

const checkParseJSONString = (jsonString = "") => {
  let parse = JSON.parse(jsonString);
  if (typeof parse === "string") {
    return JSON.parse(parse);
  }
  return parse;
};

const getBillingCutOffDate = (beginDate) => {
  let date = new Date(beginDate);
  date.setMonth(date.getMonth() + 1);
  date.setDate(date.getDate() - 1);
  return date;
};

const pad = (number) => {
  if (parseInt(number) < 10) {
    return "0" + parseInt(number);
  }
  return number;
};

const dueDate = (date, month = 1) => {
  if (date.getMonth() === 11) {
    return new Date(date.getFullYear() + 1, 0, 1);
  } else {
    return new Date(date.getFullYear(), date.getMonth() + month, 1);
  }
};

const getInstallmentDueDate = (valueCalendar) => {
  valueCalendar = getCurrentLocalDateTime(valueCalendar).fullDate;

  return dueDate(
    new Date(valueCalendar),
    new Date(valueCalendar).getDate() < 16 ? 1 : 2
  );
};

const calculatorVat = (value, VAT = 7) => {
  return round(value * getPercent(VAT), 2);
};

const calculatorInterest = (
  capital,
  interest,
  duration,
  year,
  typeRound = "roundUp"
) => {
  if (typeRound === "roundUp") {
    return roundUp(
      capital *
        (interest / 100) *
        (duration / daysInYear(new Date(year).getFullYear())),
      2
    );
  }

  return round(
    capital *
      (interest / 100) *
      (duration / daysInYear(new Date(year).getFullYear())),
    2
  );
};

const createInstallmentTFMockData = (body) => {
  const today = new Date();
  const installment_mock = {
    id: `${today.getTime()}`,
    billCutOffDate: body.billCutOffDate,
    beginDate: body.beginDate,
    dueDate: body.dueDate,
    disabledPeriod: false,
    displayStatus: "เปิด",
    pre_installments: [],
    period: body.period,
    lastPeriod: body.lastPeriod,
    min: body.min,
    max: body.max,
    is_new_installment: body.is_new_installment || false,
    demand_fee: 0,
    visit_fee: 0,
    paidVisitFee: 0,
    paidDemandFee: 0,
    duration: body.duration,
    principle: Number(Number(body.principle).toFixed(2)),
    before_interest: Number(Number(body.before_interest).toFixed(2)) || 0,
    interest: Number(Number(body.interest).toFixed(2)),
    principle_vat: Number(Number(body.principle_vat).toFixed(2)),
    interest_vat: Number(Number(body.interest_vat).toFixed(2)),
    capitalRemain: Number(Number(body.capitalRemain).toFixed(2)),
  };
  return installment_mock;
};

const getTotalAmountTF = (installments = []) => {
  let clone_installments = _.cloneDeep(installments);
  let total_obj = {
    total_interest_no_vat: 0,
    total_amount_no_vat: 0,
    total_amount_in_vat: 0,
  };
  for (const clone_installment of clone_installments) {
    total_obj.total_interest_no_vat = getNumberTwoDecimal(
      total_obj.total_interest_no_vat + clone_installment.interest
    );
    total_obj.total_amount_no_vat = getNumberTwoDecimal(
      total_obj.total_amount_no_vat +
        clone_installment.principle +
        clone_installment.interest
    );
    total_obj.total_amount_in_vat = getNumberTwoDecimal(
      total_obj.total_amount_in_vat +
        clone_installment.principle +
        clone_installment.interest +
        clone_installment.principle_vat +
        clone_installment.interest_vat
    );
  }
  return total_obj;
};

const calculateInstallmentTF = (leasing) => {
  let { requestTime, period, payPerMonth, interest, initCapital } = leasing;

  let capitalRemain = initCapital;
  let installments = [];

  let installmentBeginDate = new Date(convertTimeToDate(requestTime));
  let installmentDueDate = getInstallmentDueDate(
    new Date(convertTimeToDate(requestTime))
  );
  let beginDateFormat = getCurrentLocalDateTime(installmentBeginDate);
  let newMonthIndex = beginDateFormat.monthIndex;
  let newYear = beginDateFormat.year;

  // const interestReduction = round(
  //   calInterestReduction(initCapital, interest, period) * 12,
  //   2
  // );
  const interestReduction = interest;

  for (let index = 0; index < period; index++) {
    let beginDate = new Date(installmentBeginDate);
    let dueDate = new Date(installmentDueDate);
    let prevPrinciple = 0;

    if (index > 0) {
      prevPrinciple = installments[index - 1].principle;
      capitalRemain = getNumberTwoDecimal(capitalRemain - prevPrinciple);

      let prevDueDate = new Date(installments[index - 1].dueDate);

      newMonthIndex += 1;
      if (newMonthIndex > 11) {
        newYear += 1;
        newMonthIndex = 0;
        beginDate = `${newYear}-01-${beginDateFormat.date}`;
      } else {
        beginDate = `${newYear}-${pad(newMonthIndex + 1)}-${
          beginDateFormat.date
        }`;
      }

      prevDueDate = getInstallmentDueDate(new Date(prevDueDate));
      dueDate = prevDueDate;
    }

    let billCutOffDate = getBillingCutOffDate(new Date(beginDate));

    let duration = getDifferenceInDays(beginDate, dueDate);
    let installmentInterest = calculatorInterest(
      capitalRemain,
      interestReduction,
      duration,
      new Date(dueDate).getFullYear(),
      "round"
    );
    let installmentCapital = payPerMonth - installmentInterest;
    if (installmentCapital > capitalRemain) installmentCapital = capitalRemain;
    if (index === leasing.period - 1) installmentCapital = capitalRemain;

    let principle_vat = calculatorVat(installmentCapital);
    let interest_vat = calculatorVat(installmentInterest);

    let objInstallment = createInstallmentTFMockData({
      billCutOffDate: getCurrentLocalDateTime(billCutOffDate).fullDate,
      beginDate: getCurrentLocalDateTime(beginDate).fullDate,
      dueDate: getCurrentLocalDateTime(dueDate).fullDate,
      disabledPeriod: false,
      displayStatus: "เปิด",
      pre_installments: [],
      period: Number(`${index + 1}`),
      lastPeriod: Number(`${index + 1}.00`),
      min: Number(index + 1),
      max: Number(`${index + 1}.99`),
      principle: installmentCapital,
      interest: installmentInterest,
      principle_vat,
      interest_vat,
      duration,
      capitalRemain,
    });
    installments.push(objInstallment);
  }

  return installments;
};

const calculateInstallmentNTF = (leasing) => {
  let { requestTime, period, initCapital, payPerMonth, interest } = leasing;

  let installments = [];
  let capitalRemain = initCapital;

  let installmentBeginDate = new Date(convertTimeToDate(requestTime));
  let installmentDueDate = getInstallmentDueDate(
    new Date(convertTimeToDate(requestTime))
  );
  let beginDateFormat = getCurrentLocalDateTime(installmentBeginDate);
  let newMonthIndex = beginDateFormat.monthIndex;
  let newYear = beginDateFormat.year;

  for (let index = 0; index < period; index++) {
    let beginDate = new Date(installmentBeginDate);
    let dueDate = new Date(installmentDueDate);
    let prevPrinciple = 0;

    if (index > 0) {
      prevPrinciple = installments[index - 1].principle;
      capitalRemain = getNumberTwoDecimal(capitalRemain - prevPrinciple);

      let prevDueDate = new Date(installments[index - 1].dueDate);

      newMonthIndex += 1;
      if (newMonthIndex > 11) {
        newYear += 1;
        newMonthIndex = 0;
        beginDate = `${newYear}-01-${beginDateFormat.date}`;
      } else {
        beginDate = `${newYear}-${pad(newMonthIndex + 1)}-${
          beginDateFormat.date
        }`;
      }

      prevDueDate = getInstallmentDueDate(new Date(prevDueDate));
      dueDate = prevDueDate;
    }

    let billCutOffDate = getBillingCutOffDate(new Date(beginDate));

    let duration = getDifferenceInDays(beginDate, dueDate);
    let installmentInterest = calculatorInterest(
      capitalRemain,
      interest,
      duration,
      new Date(dueDate).getFullYear(),
      "round"
    );
    let installmentCapital = payPerMonth - installmentInterest;
    if (installmentCapital > capitalRemain) installmentCapital = capitalRemain;
    if (index === leasing.period - 1) installmentCapital = capitalRemain;

    let objInstallment = {
      billCutOffDate: getCurrentLocalDateTime(billCutOffDate).fullDate,
      beginDate: getCurrentLocalDateTime(beginDate).fullDate,
      dueDate: getCurrentLocalDateTime(dueDate).fullDate,
      disabledPeriod: false,
      displayStatus: "เปิด",
      pre_installments: [],
      period: Number(`${index + 1}`),
      lastPeriod: Number(`${index + 1}.00`),
      principle: installmentCapital,
      interest: installmentInterest,
      min: Number(index + 1),
      max: Number(`${index + 1}.99`),
    };
    installments.push(objInstallment);
  }

  return installments;
};

const getInformationTF = (body, today = new Date()) => {
  const todayTransferDate = new Date();
  const todayFormat = getCurrentLocalDateTime();
  const checkTransferDate = `${todayFormat.fullDate}T12:00:00+07:00`;

  const todayTransferDateFormat = getCurrentLocalDateTime(todayTransferDate);

  // if (body.type === "MOTORBIKE") {
  //   body.initCapital = getCapitalRemainMotobike(body.initCapital, body.loanFee);
  // }

  const calRequestamount = getRequestAmountAfter(body, getFeeDropDown(body));

  if (body.category === "TF") {
    let payPerMonth = calculatePayPerMonthPerYear(
      calRequestamount,
      body.interest,
      body.period
    );

    let installments = calculateInstallmentTF({
      ...body,
      payPerMonth,
      initCapital: calRequestamount,
      capitalRemain: calRequestamount,
      requestTime: todayTransferDateFormat.isoDateTime,
    });

    const receiveAmount =
      body.type === "CAR"
        ? getReceiveAmountCar(calRequestamount, body.loanFee, body.stamp)
        : getReceiveAmountMotobike(calRequestamount, body.loanFee, body.stamp);

    let vat_tf = {
      vat: getNumberTwoDecimal(
        installments[0].interest_vat + installments[0].principle_vat
      ),
      // interestReduction: 0,
      total_interest_no_vat: 0,
      total_amount_no_vat: 0,
      total_amount_in_vat: 0,
      total_amount_per_period: calTotalLeasing(installments[0]),
    };

    const gotTotalAmountTF = getTotalAmountTF(installments);
    // vat_tf.interestReduction = getNumberTwoDecimal(
    //   calInterestReduction(body.initCapital, body.interest, body.period) * 12
    // );
    vat_tf.total_amount_in_vat = gotTotalAmountTF.total_amount_in_vat;
    vat_tf.total_amount_no_vat = gotTotalAmountTF.total_amount_no_vat;
    vat_tf.total_interest_no_vat = gotTotalAmountTF.total_interest_no_vat;
    return {
      ...vat_tf,
      installments,
      startDueDate:
        body?.loan_status === "สมบูรณ์"
          ? body?.startDueDate
          : installments[0].dueDate,
    };
  } else {
    let payPerMonth = calculatePayPerMonth(
      calRequestamount,
      body.interest,
      body.period,
      body.category
    );

    let installments = calculateInstallmentNTF({
      ...body,
      payPerMonth,
      initCapital: calRequestamount,
      capitalRemain: calRequestamount,
      requestTime: todayTransferDateFormat.isoDateTime,
    });
    return {
      installments,
      startDueDate:
        body?.loan_status === "สมบูรณ์"
          ? body?.startDueDate
          : installments[0].dueDate,
    };
  }
};

const getAfterFee = (initCapital, fee, receiveAmount) => {
  return round(fee * (initCapital / 100), 0);
};

const getRequestAmountAfter = (body, fees = []) => {
  let total = 0;
  fees.forEach((fee) => {
    total += fee.value;
  });
  return body.amount - total;
};

const getFeeDropDown = (body) => {
  return [
    {
      label: "ค่าอากรสแตมป์",
      value: getAfterFee(body.amount, body.stamp, body.receiveAmount),
    },
    {
      label:
        body.type === "CAR" ? "ค่าประเมินรถยนต์" : "ค่าธรรมเนียมการใช้วงเงิน",
      value: getAfterFee(body.amount, body.loanFee, body.receiveAmount),
    },
  ];
};

const getInterestReduction = (initCapital, interest, period) => {
  return round(calInterestReduction(initCapital, interest, period) * 12, 2);
};

const getTotalInterestNoVat = (form) => {
  return Number((((form.amount * form.raw_interest) / 100) * form.period) / 12);
};

export {
  getTotalInterestNoVat,
  getInterestReduction,
  getFeeDropDown,
  getRequestAmountAfter,
  getAfterFee,
  getInformationTF,
  checkParseJSONString,
  tryParseJSON,
  getStatments,
  getAfterVat,
  getBeforeVat,
  getAmountOwedDueTF,
  getAmountOwedDueNTF,
  getTotalOfPreInstallmentsHalf,
  getLastDemandFee,
  prePareQueryRequest,
  getDifferenceInDays,
  getAmountPlusReturnCarFee,
  getAmountReturnCarFee,
  getFeeTypeText,
  getStyleStatus,
  getLastItem,
  getCapital,
  getCapitalRemainMotobike,
  calculatePayPerMonthPerYear,
  calInterestReduction,
  calculatePayPerMonthReduction,
  calculatePayPerMonth,
  getFilterInstallments,
  getFormatDate,
  roundUp,
  round,
  RATE,
  getPaidTotalNTF,
  calPaidRemain,
  calTotalLeasing,
  getTotalNTF,
  getDiffRemain,
  getNumberTwoDecimal,
  getSysUpdateBy,
  getAmount,
  getReceiveAmountMotobike,
  getReceiveAmountCar,
  getFeeMotobike,
  getFee,
  getPercent,
};
